import { render, staticRenderFns } from "./LogDetail.vue?vue&type=template&id=20a6b7f1"
import script from "./LogDetail.vue?vue&type=script&lang=js"
export * from "./LogDetail.vue?vue&type=script&lang=js"
import style0 from "./LogDetail.vue?vue&type=style&index=0&id=20a6b7f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports